<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Cotação</mat-card-title>
    </div>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-8">
    <mat-card class="card-style px-4 py-6">
      <h5>Proposta</h5>
      <div class="flex justify-between items-center gap-4 mb-4">
        <div class="w-1/4"><b>tg cod:</b> {{ proposal.tg }}</div>
        <div class="w-1/4"><b>Evento:</b> {{ proposal.nomeEvento }}</div>
        <div class="w-1/4"><b>Inicio:</b> {{ proposal.dataEventoInicio }}</div>
        <div class="w-1/4"><b>Fim:</b> {{ proposal.dataEventoFim }}</div>
      </div>
      <div class="flex justify-between items-center gap-4 mb-4">
        <div class="w-1/4"><b>Cliente:</b> {{ proposal.nome }}</div>
        <div class="w-1/4">
          <b>Subcliente:</b> {{ proposal.subClienteNome ?? '-' }}
        </div>
        <div class="w-1/4">
          <b>Consultor Cliente:</b> {{ proposal.consultorComercialNome }}
        </div>
        <div class="w-1/4">
          <b>Consultor Comercial:</b> {{ proposal.consultorNome ?? '-' }}
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="flex justify-between items-center gap-4 mt-4">
        <h5>Trecho</h5>
        <button
          mat-raised-button
          class="btn-add"
          (click)="viewItinerariesItem()"
        >
          <mat-icon>route</mat-icon>
          Itinerários
        </button>
      </div>
      <div class="flex justify-between items-center gap-4 mb-4">
        <div class="w-1/4"><b>Status:</b> {{ item.statusSolicitacao }}</div>
        <div class="w-1/4">
          <b>Origem:</b>
          Cidade: {{ item.cidadeOrigem }}<br />
          Estado: {{ item.estadoOrigem }}
          <!--          {{ item.origem }}-->
        </div>
        <div class="w-1/4">
          <b>Destino:</b>
          Cidade: {{ item.cidadeDestino }}<br />
          Estado: {{ item.estadoDestino }}
          <!--          {{ item.destino }}-->
        </div>
        <div class="w-1/4">
          <b>Período:</b> {{ item.itemDataInicio }} - {{ item.itemDataFinal }}
        </div>
      </div>
      <div class="flex justify-between items-center gap-4 mb-4">
        <div class="w-1/4"><b>Tipo de serviço:</b> {{ item.tipoServico }}</div>
        <div class="w-1/4"><b>Serviço:</b> {{ item.servico }}</div>
        <div class="w-1/4">
          <b>Tipo veículo:</b> {{ item.tipoVeiculo ?? '-' }}
        </div>
        <div class="w-1/4">
          <b>Tipo motorista:</b> {{ item.tipoMotorista ?? '-' }}
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="flex justify-between items-center gap-4 mt-4">
        <div class="w-full">
          <b>Observação:</b><br />
          <div class="text-base font-semibold text-red-800">
            {{ item.observacao ?? '' }}
          </div>
        </div>
      </div>
    </mat-card>
    <div class="mt-6">
      <!--  <form-client-search-->
      <!--    [search]="inputSearchContact"-->
      <!--    [listSearch]="listSearch"-->
      <!--    (responseSearch)="search($event)"-->
      <!--  />-->
      @if (!loading) {
        <div class="tab-overflow">
          <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
            @for (column of columns; track column.keyColumn) {
              <ng-container matColumnDef="{{ column.keyColumn }}">
                <th mat-header-cell *matHeaderCellDef>
                  {{ column.description }}
                </th>
                <td mat-cell *matCellDef="let element">
                  @if (column.keyColumn == 'action') {
                    <div class="flex justify-center items-center gap-3">
                      @if (element.statusId != 3) {
                        <mat-icon
                          class="btn-icon-outline"
                          fontIcon="edit"
                          matTooltip="Atualizar valor"
                          (click)="updatePrice(element)"
                        />
                      } @else {
                        <mat-icon
                          class="btn-icon-outline disabled"
                          fontIcon="edit"
                          matTooltip=""
                        />
                      }
                      @if (element.statusId == 2 && !tariffExist) {
                        <mat-icon
                          class="btn-icon-outline"
                          fontIcon="newspaper"
                          matTooltip="Criar tarifário"
                          (click)="createTariffPrice(element)"
                        />
                      } @else {
                        <mat-icon
                          class="btn-icon-outline disabled"
                          fontIcon="newspaper"
                          matTooltip=""
                        />
                      }
                    </div>
                  } @else if (column.keyColumn == 'cnpj') {
                    {{ element[column.key] | cnpj }}
                  } @else {
                    {{ element[column.key] }}
                  }
                </td>
              </ng-container>
            }

            <tr
              mat-header-row
              class="style-header"
              *matHeaderRowDef="displayedColumns"
            ></tr>
            <tr
              mat-row
              class="style-row"
              *matRowDef="let row; columns: displayedColumns"
            ></tr>
          </table>
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
      <div class="py-3">
        <mat-paginator
          [pageSizeOptions]="[10, 50, 100]"
          [hidden]="loading"
          #paginator
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</mat-card>
